// MobileOfflineBanner — persistent banner showing queued-action count and online status.
// Used across the BoH PWA screens (Phase E of Client-Surfaces Programme).
import React from 'react';
import { WifiOff, RefreshCw, CheckCircle2 } from 'lucide-react';
import { useSyncQueue } from '../utils/syncQueue';

const MobileOfflineBanner = () => {
  const { queuedCount, online, flush } = useSyncQueue();

  if (online && queuedCount === 0) {
    // Nothing to surface in the happy path — keep UI quiet.
    return null;
  }

  if (!online) {
    return (
      <div className="offline-banner px-4 py-2 flex items-center justify-between text-sm" data-testid="mobile-offline-banner">
        <div className="flex items-center gap-2">
          <WifiOff className="w-4 h-4" />
          <span>Offline — your actions are being saved locally</span>
        </div>
        {queuedCount > 0 ? (
          <span className="font-data tabular-nums text-xs" data-testid="mobile-queue-count">
            {queuedCount} queued
          </span>
        ) : null}
      </div>
    );
  }

  // Online but queue still has items — usually mid-flush.
  return (
    <div className="bg-primary-50 text-primary-700 px-4 py-2 flex items-center justify-between text-sm" data-testid="mobile-sync-banner">
      <div className="flex items-center gap-2">
        <RefreshCw className="w-4 h-4 animate-spin" />
        <span>Syncing <span data-testid="mobile-queue-count" className="font-data tabular-nums">{queuedCount}</span> action{queuedCount === 1 ? '' : 's'}…</span>
      </div>
      <button
        onClick={flush}
        className="text-xs underline"
        data-testid="mobile-sync-retry-btn"
      >
        Retry now
      </button>
    </div>
  );
};

export const MobileSyncOK = () => (
  <div className="bg-ok/10 text-ok px-4 py-2 flex items-center gap-2 text-xs" data-testid="mobile-sync-ok-banner">
    <CheckCircle2 className="w-4 h-4" /> All actions synced
  </div>
);

export default MobileOfflineBanner;
